var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 3.29901C7.2933 3.42463 6.36113 3.79164 5.55 4.39999L3.35 6.04999C2.65753 6.56934 2.25 7.38441 2.25 8.24999V16.879C2.25 19.092 4.77641 20.3552 6.54677 19.0274C7.06228 18.6408 7.64605 18.3913 8.25 18.2788V3.29901Z",
    fill: "#24262E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 18.2788C10.3539 18.3913 10.9377 18.6408 11.4532 19.0274L11.55 19.1C12.3611 19.7083 13.2933 20.0753 14.25 20.201V5.22114C13.6461 5.10871 13.0623 4.8592 12.5468 4.47257L12.45 4.39999C11.6389 3.79164 10.7067 3.42463 9.75 3.29901V18.2788Z",
    fill: "#24262E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 5.22114V20.201C16.7067 20.0753 17.6389 19.7083 18.45 19.1L20.65 17.45C21.3425 16.9306 21.75 16.1156 21.75 15.25V6.62096C21.75 4.408 19.2236 3.14479 17.4532 4.47257C16.9377 4.8592 16.3539 5.10871 15.75 5.22114Z",
    fill: "#24262E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/Map.a8c065255bb57c979b8e848066faa21b.svg";
export { ForwardRef as ReactComponent };